import {faH} from "@fortawesome/free-solid-svg-icons";

export default faH;
